import React from "react";

function ExclamationRedIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3104_3329)">
        <path
          d="M8.5 -0.0205078C12.9184 -0.0205078 16.5 3.56189 16.5 7.97949C16.5 12.3971 12.9184 15.9795 8.5 15.9795C4.0816 15.9795 0.5 12.3971 0.5 7.97949C0.5 3.56189 4.0816 -0.0205078 8.5 -0.0205078ZM8.5 1.31309C4.824 1.31309 1.8336 4.30349 1.8336 7.97949C1.8336 11.6555 4.824 14.6459 8.5 14.6459C12.176 14.6459 15.1664 11.6555 15.1664 7.97949C15.1664 4.30349 12.176 1.31309 8.5 1.31309ZM8.4992 9.98109C8.71116 9.98109 8.91444 10.0653 9.06432 10.2152C9.2142 10.3651 9.2984 10.5683 9.2984 10.7803C9.2984 10.9923 9.2142 11.1955 9.06432 11.3454C8.91444 11.4953 8.71116 11.5795 8.4992 11.5795C8.28724 11.5795 8.08396 11.4953 7.93408 11.3454C7.7842 11.1955 7.7 10.9923 7.7 10.7803C7.7 10.5683 7.7842 10.3651 7.93408 10.2152C8.08396 10.0653 8.28724 9.98109 8.4992 9.98109ZM8.4952 3.97949C8.64033 3.9793 8.7806 4.03173 8.89004 4.12704C8.99948 4.22236 9.07066 4.35411 9.0904 4.49789L9.096 4.57869L9.0992 8.18029C9.09936 8.33238 9.04175 8.47885 8.93803 8.59009C8.83431 8.70132 8.69222 8.76902 8.5405 8.77949C8.38877 8.78996 8.23873 8.74241 8.12072 8.64647C8.0027 8.55054 7.92553 8.41336 7.9048 8.26269L7.8992 8.18109L7.896 4.58029C7.8959 4.50143 7.91134 4.42332 7.94144 4.35044C7.97155 4.27755 8.01573 4.21131 8.07145 4.15551C8.12718 4.09971 8.19336 4.05544 8.2662 4.02524C8.33905 3.99504 8.41634 3.97949 8.4952 3.97949Z"
          fill="#F44336"
        />
      </g>
      <defs>
        <clipPath id="clip0_3104_3329">
          <rect width="17" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ExclamationRedIcon;
